import { Component } from "@angular/core";

@Component({
  selector: "app-public-header",
  standalone: true,
  imports: [],
  templateUrl: "./public-header.component.html",
})
export class PublicHeaderComponent {}
